import styled from 'styled-components';
import { getBodyStyle, getColor, Theme } from 'styles/theme';
import Heading from 'styles/typography/Heading';

export const SectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;

  [role="tabpanel"]:not(.is-hidden) {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .tab-controls {
    button {
      height: 50px;
    }
  }
`;

export const Categories = styled.div<{ theme: Theme }>`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 18px;

  span {
    border-radius: 8px;
    background: ${getColor('shadeBrandPrimary100')};
    color: ${getColor('textPrimary')};
    padding: 12px;
    cursor: pointer;
    ${getBodyStyle('graphikCond', { default: 'small' }, 'semiBold')};
    
    &:hover {
      background: ${getColor('shadeBrandPrimary200')};
    }
  }

  span.selected {
    background: ${getColor('surfaceBrand')};
    color: ${getColor('textWhite')};
  }
`;

export const SectionTitle = styled(Heading)`
  border-bottom: 1px solid ${getColor('borderBlack')};
`;
